import gql from 'graphql-tag';

export const DeleteParticipantQR = gql`
  mutation deleteParticipantQr($organizationId: ID!, $participantId: ID!, $qrId: ID!) {
    deleteParticipantQr(organizationId: $organizationId, participantId: $participantId, qrId: $qrId) {
      id
    }
  }
`;
